/**
 * Main App Component
 * Sets up routing and initializes auth state
 */

import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './stores/auth-store';

// Layout
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import Login from './pages/Login';
import Signup from './pages/Signup';
import Explore from './pages/Explore';
import ExploreMovies from './pages/ExploreMovies';
import VisualDiscovery from './pages/VisualDiscovery';
import Forage from './pages/Forage';
import OAuthCallback from './pages/OAuthCallback';
import NotFound from './pages/NotFound';

function App() {
  const { initialize } = useAuthStore();

  // Initialize auth state on mount
  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/oauth/callback" element={<OAuthCallback />} />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/explore" replace />} />
          <Route path="search" element={<Navigate to="/explore" replace />} />
          <Route path="explore" element={<Explore />} />
          <Route path="movies" element={<ExploreMovies />} />
          <Route path="constellations" element={<Navigate to="/explore" replace />} />
          <Route path="visual" element={<VisualDiscovery />} />
          <Route path="forage" element={<Forage />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
